/* The sheet body's states: loading, empty, and the back row that leads out
   of a playlist. */

.empty {
  padding: 40px 24px;
  text-align: center;
  color: var(--ink-2);
  font-size: 14px;
  line-height: 1.5;
}

.empty strong {
  display: block;
  color: var(--ink);
  font-size: 16px;
  font-weight: 650;
  margin-bottom: 6px;
  letter-spacing: -0.02em;
}

.spinner {
  width: 22px;
  height: 22px;
  margin: 34px auto;
  border-radius: 50%;
  border: 2.5px solid rgba(11, 31, 23, 0.12);
  border-top-color: var(--accent);
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.backrow {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 6px 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--accent-deep);
  letter-spacing: -0.01em;
}

.backrow svg {
  width: 18px;
  height: 18px;
}
